import React, { FC } from 'react';
import { ApolloProvider as Provider } from '@apollo/client';
import { apolloClient } from 'src/utilities';

export const ApolloProvider: FC = ({ children }) => {
  return <Provider client={apolloClient}>{children}</Provider>;
};
